export type Course = {
  value: string;
  label: string;
  certificateValidityPeriod: string;
};

export type DeletingCourse = {
  id: string;
  name: string;
  status: string;
};
export type LevelCourse = {
  id: string;
  course: Course;
  action: PositionProgramsActionEnum;
  dateActiveStatus: string;
  dateInactiveStatus: string;
  status: Course;
  name?: string;
  certificateValidityPeriod?: number;
};
export type ChangedCourseDetails = {
  status: Course;
  course: Course;
  certificateValidityPeriod?: number;
};
export interface IGraphQLLevel {
  id: string;
  name: string;
  status: string;
  sequenceNumber: number;
  isCertification: boolean;
}

export enum PositionProgramsActionEnum {
  create = "create",
  edit = "edit",
  delete = "delete",
}
